import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ServiceRow = ({ num, title, short, slug, testId }) => {
  return (
    <Link
      to={`/servizi/${slug}`}
      className="service-row block py-8 md:py-10 group"
      data-testid={testId}
      data-hover="true"
    >
      <div className="grid grid-cols-12 gap-4 md:gap-8 items-center">
        <span className="font-display col-span-2 md:col-span-1 text-3xl md:text-5xl text-mandrogni leading-none">
          {num}
        </span>
        <div className="col-span-10 md:col-span-8">
          <h3 className="font-display text-2xl md:text-4xl leading-tight mb-2 group-hover:text-lime transition-colors">
            {title}
          </h3>
          <p className="text-[1rem] md:text-[1.0625rem] opacity-80 max-w-[60ch]">
            {short}
          </p>
        </div>
        <div className="hidden md:flex col-span-3 justify-end">
          <span className="inline-flex items-center gap-2 font-condensed uppercase tracking-widest text-sm group-hover:text-lime transition-colors">
            Scopri
            <ArrowUpRight size={20} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ServiceRow;
